import React, { useEffect, useState } from 'react';
import '../mail/SendMailScreen.css';
import '../styles/MainContainer.css';
import SendMailScreen from '../mail/SendMailScreen';
import { useParams } from 'react-router-dom';
import api from '../wrapper/API';
import OfflineBanner from '../shell/OfflineBanner';

// Direktversand einer Vorlagen-Mail an einen Spieler — ohne Spieltag-Kontext.
function PlayerMail() {
  const { playerId } = useParams();
  const [postPlayer, setPostPlayer] = useState({});

  useEffect(() => {
    api.get(`/Player/GetPlayerById?playerId=${playerId}`)
      .then(response => setPostPlayer(response.data))
      .catch(() => {});
  }, [playerId]);

  return (
    <React.Fragment>
      <main className={'wideMain'}>
        <OfflineBanner />
        <SendMailScreen postPlayer={postPlayer} />
      </main>
    </React.Fragment>
  );
}

export default PlayerMail;
